import { Star } from 'lucide-react';
import { useMemo } from 'react';

const Testimonials = () => {
  const testimonials = useMemo(() => [
    {
      id: 'sarah-johnson',
      name: 'Dr. Sarah Johnson',
      role: 'Clinic Director, Orlando Health Center',
      image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400',
      rating: 5,
      text: 'Medical Supply and More has been our go-to supplier for over two years. Their products are top-quality, prices are competitive, and delivery is always prompt. Highly recommended for healthcare facilities!'
    },
    {
      id: 'michael-rodriguez',
      name: 'Michael Rodriguez',
      role: 'Home Care Provider',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400',
      rating: 5,
      text: 'I provide home care for elderly patients and rely on Medical Supply and More for all my supplies. The website is easy to use, customer service is excellent, and they always have what I need in stock.'
    },
    {
      id: 'jennifer-martinez',
      name: 'Jennifer Martinez',
      role: 'Physical Therapist',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400',
      rating: 5,
      text: 'As a physical therapist, I need reliable equipment and supplies. This company delivers every time. Their mobility aids are high-quality and their prices for bulk orders are unbeatable.'
    },
    {
      id: 'robert-chen',
      name: 'Robert Chen',
      role: 'Small Clinic Owner',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
      rating: 5,
      text: 'Running a small clinic means watching every penny. Medical Supply and More offers great prices without compromising on quality. Their bulk ordering options have saved us thousands!'
    },
    {
      id: 'lisa-thompson',
      name: 'Lisa Thompson',
      role: 'Registered Nurse',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400',
      rating: 5,
      text: 'I have ordered from many medical supply companies, but this one stands out. Fast shipping, quality products, and their customer service team actually cares. They have earned my trust and business.'
    },
    {
      id: 'david-williams',
      name: 'David Williams',
      role: 'Family Caregiver',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
      rating: 5,
      text: 'Taking care of my elderly parents requires many medical supplies. This company makes it easy with their user-friendly website and reliable delivery. The products are always exactly as described.'
    }
  ], []);

  // Generate star keys for reusable star arrays
  const starKeys = useMemo(() => ['star-1', 'star-2', 'star-3', 'star-4', 'star-5'], []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-medical-primary text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-heading font-semibold mb-4">Customer Testimonials</h1>
          <p className="text-white/90">See what our customers are saying about us</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            {starKeys.map((key) => (
              <Star key={key} className="w-8 h-8 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          <p className="text-2xl font-semibold text-gray-900">Trusted by Healthcare Professionals</p>
          <p className="text-gray-600 mt-2">Join thousands of satisfied customers who trust us for their medical supply needs</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow" data-testid={`testimonial-${testimonial.id}`}>
              <div className="flex items-center mb-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="font-medium text-gray-900">{testimonial.name}</h3>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
              <div className="flex mb-3">
                {starKeys.slice(0, testimonial.rating).map((key) => (
                  <Star key={`${testimonial.id}-${key}`} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <p className="text-gray-600 leading-relaxed italic">{testimonial.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-medical-accent rounded-xl p-8 text-center">
          <h3 className="text-2xl font-heading font-semibold mb-2">Ready to Experience Quality Service?</h3>
          <p className="text-gray-600 mb-6">Join our satisfied customers and order your medical supplies today</p>
          <a href="/shop" className="inline-block bg-medical-primary text-white px-8 py-3 rounded-lg hover:bg-medical-primary/90 transition-colors" data-testid="shop-now-button">
            Shop Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
